import {Navigate, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {api} from "../../utils/api";
import axios from "axios";

export const ProtectedRoute = ({ children }) => {

    return children;

}

// function getCookie(name) {
//     let nameEQ = name + "=";
//     let ca = document.cookie.split(';');
//     for (let i = 0; i < ca.length; i++) {
//         let c = ca[i];
//         while (c.charAt(0) == ' ') c = c.substring(1, c.length);
//         if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//     }
//     return null;
// }